<script>
  import BaseModal from "@/components/partials/base-modal/Index.vue"
  import TextareaField from "@/components/partials/inputs/TextareaField.vue";
  import Errors from "@/services/Errors";
  import API from "@/utils/input-output/api";
  import constants from "@/components/notifications/constants";
  import trackResponse from "@/utils/miscellaneous/track-response";

  export default {
    components: { TextareaField, BaseModal },

    props: {
      notification: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        reason: "",
        errors: new Errors({}),
        isSubmitting: false,
      };
    },

    computed: {
      campaignApplicationID() {
        return this.notification.content.campaignApplicationId;
      },

      userPersona() {
        return this.$store.getters["User/userPersona"];
      },

      actionsStatus() {
        if (this.isSubmitting) {
          return {
            primary: "loading",
            cancel: "disabled",
            close: "disabled",
          };
        }
        return {
          primary: "enabled",
          cancel: "enabled",
          close: "enabled",
        };
      },
    },

    methods: {
      cancel() {
        this.$emit("cancel");
      },

      confirm() {
        if (!this.reason) {
          this.errors.recordField({
            reason: this.$t("errors.fieldIsRequired"),
          })
          return;
        }
        this.rejectApplication()
      },

      rejectApplication() {
        this.isSubmitting = true;

        API({
          url: constants.rejectApplication({
            campaignApplicationID: this.campaignApplicationID,
            persona: this.userPersona,
          }),
          params: {
            reason: this.reason,
            status: "rejected",
          },
          method: "PUT",
          requestId: "rejectApplication",
        }).then(() => {
          trackResponse({
            type: "success",
            msg: this.$t("messages.recordUpdatedSuccessfully"),
          });
          this.isSubmitting = false;

          this.$emit("application-rejected")
        }).catch(() => {
          this.isSubmitting = false;
        })
      },

      updateValue({ value }) {
        this.errors.clear()
        this.reason = value;
      },
    },
  };
</script>

<template>
  <BaseModal
    title="rejectionReason"
    width="600px"
    :actions-status="actionsStatus"
    @primary-action="confirm"
    @cancel="cancel"
  >
    <div class="col-12">
      <TextareaField
        :value="reason"
        input-id="application"
        :theme="errors.has('reason') ? 'error' : 'neutral'"
        :message="errors.get('reason')"
        placeholder="rejectionReason"
        @update-value="updateValue"
        @submit="confirm"
      />
    </div>
  </BaseModal>
</template>
